import React, { useState } from "react";

// Mismos tokens que HomeBoldSunset.jsx / Navbar.jsx / About.jsx / Projects.jsx
const COLORS = {
  bg: "#200A08",
  surface: "#341210",
  surfaceAlt: "#411713",
  orange: "#FF7A33",
  gold: "#FFC93C",
  teal: "#2EC4B6",
  ink: "#FBEDE2",
  muted: "#C9A79B",
};

const FONT_DISPLAY = '"Arial Black", "Helvetica Neue", Arial, sans-serif';
const FONT_BODY = 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
const FONT_MONO = 'ui-monospace, "Cascadia Code", "SFMono-Regular", Menlo, monospace';

const fieldStyle = {
  width: "100%",
  padding: "0.75rem 1rem",
  background: COLORS.surfaceAlt,
  color: COLORS.ink,
  border: `1px solid ${COLORS.surface}`,
  borderRadius: 8,
  fontFamily: FONT_BODY,
  outline: "none",
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí puedes manejar el envío del formulario, por ejemplo, enviarlo a un servidor
    alert("Formulario enviado!");
    setFormData({ name: "", email: "", message: "" }); // Limpiar formulario
  };

  const focusStyle = (e) => (e.target.style.borderColor = COLORS.orange);
  const blurStyle = (e) => (e.target.style.borderColor = COLORS.surface);

  return (
    <div style={{ background: COLORS.bg, color: COLORS.ink, fontFamily: FONT_BODY }} className="min-h-screen w-full">
      <div className="max-w-2xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p
          style={{ fontFamily: FONT_MONO, color: COLORS.teal, letterSpacing: "0.15em" }}
          className="text-xs md:text-sm uppercase mb-6"
        >
          Hablemos
        </p>

        <div className="relative inline-block mb-12">
          <span style={{ background: COLORS.orange, transform: "skewY(-2deg)" }} className="absolute inset-0 -z-0" />
          <h1
            style={{ fontFamily: FONT_DISPLAY, color: COLORS.bg, letterSpacing: "-0.02em" }}
            className="relative z-10 text-4xl md:text-6xl uppercase px-3 py-1"
          >
            Contacto
          </h1>
        </div>

        <div id="Contact" style={{ background: COLORS.surface, borderRadius: 14 }} className="p-6 md:p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                htmlFor="name"
                style={{ fontFamily: FONT_MONO, color: COLORS.muted, letterSpacing: "0.08em" }}
                className="block mb-2 text-xs uppercase"
              >
                Nombre
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                onFocus={focusStyle}
                onBlur={blurStyle}
                required
                style={fieldStyle}
              />
            </div>

            <div>
              <label
                htmlFor="email"
                style={{ fontFamily: FONT_MONO, color: COLORS.muted, letterSpacing: "0.08em" }}
                className="block mb-2 text-xs uppercase"
              >
                Correo electrónico
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onFocus={focusStyle}
                onBlur={blurStyle}
                required
                style={fieldStyle}
              />
            </div>

            <div>
              <label
                htmlFor="message"
                style={{ fontFamily: FONT_MONO, color: COLORS.muted, letterSpacing: "0.08em" }}
                className="block mb-2 text-xs uppercase"
              >
                Mensaje
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                onFocus={focusStyle}
                onBlur={blurStyle}
                required
                rows="5"
                style={fieldStyle}
              />
            </div>

            <button
              type="submit"
              style={{ background: COLORS.gold, color: COLORS.bg, fontFamily: FONT_DISPLAY, borderRadius: 8 }}
              className="w-full py-3 uppercase tracking-wide hover:opacity-90 transition-opacity"
            >
              Enviar mensaje
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;